/** دسترسی به بخش شکایات: نقش admin/superadmin یا پرچم داده‌شده توسط ادمین اصلی. */
export function canAccessComplaints(): boolean {
  const r = (localStorage.getItem('admin_role') || '').trim().toLowerCase();
  if (r === 'admin' || r === 'superadmin') return true;
  return localStorage.getItem('admin_complaints_access') === '1';
}

/** مدیر کل (role=admin) — مثلاً برای حذف دائمی شکایات */
export function isMainAdmin(): boolean {
  return (localStorage.getItem('admin_role') || '').trim().toLowerCase() === 'admin';
}

export function setComplaintsAccessFromLogin(value: boolean | undefined | null): void {
  localStorage.setItem('admin_complaints_access', value ? '1' : '0');
}

export function clearComplaintsAccess(): void {
  localStorage.removeItem('admin_complaints_access');
}
